// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.apps-loader{margin:40px;padding:40px;min-width:300px}`, "",{"version":3,"sources":["webpack://./src/components/list-base/list-base.scss"],"names":[],"mappings":"AAAA,aACE,WAAA,CACA,YAAA,CACA,eAAA","sourcesContent":[".apps-loader {\n  margin: 40px;\n  padding: 40px;\n  min-width: 300px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
